<template>
    <div>
        <ConfirmHeader/>
        <SectionLabel>申込者名入力</SectionLabel>
        <section class="content">
            <FormConfirm label="名前" :value="`${request.name1} ${request.name2}`"/>
            <FormConfirm label="カナ" :value="`${request.kana1} ${request.kana2}`"/>
        </section>
        <SectionLabel>住所</SectionLabel>
        <section class="content">
            <FormConfirm label="郵便番号" :value="request.postcode"/>
            <FormConfirm label="都道府県" :value="request.pref"/>
            <FormConfirm label="市区町村" :value="request.city"/>
            <FormConfirm label="それ以降の住所" :value="request.address"/>
            <FormConfirm label="マンション・建物名" :value="request.bill"/>
        </section>
        <SectionLabel>電話番号</SectionLabel>
        <section class="content">
            <FormConfirm label="電話番号" :value="request.tel"/>
        </section>
        <SectionLabel>メールアドレス</SectionLabel>
        <section class="content">
            <FormConfirm label="メールアドレス" :value="request.email"/>
        </section>
        <SectionLabel>職種</SectionLabel>
        <section class="content">
            <FormConfirm label="職種" :value="request.industry"/>
        </section>
        <SectionLabel>資格を知られたきっかけは？</SectionLabel>
        <section class="content">
            <FormConfirm label="資格を知られたきっかけは？" :value="request.trigger"/>
        </section>
        <SectionLabel>現在公式テキストをお持ちですか?</SectionLabel>
        <section class="content">
            <FormConfirm label="現在公式テキストをお持ちですか?" :value="Boolean(Number(request.has_text)) ? 'はい' : 'いいえ'"/>
        </section>
        <SectionLabel>お支払い方法</SectionLabel>
        <section class="content">
            <FormConfirm label="お支払い方法" :value="request.payment_type === 'credit' ? 'クレジットカード' : 'コンビニ後払い'"/>
            <div v-if="request.payment_type === 'credit'">
                <FormConfirm label="カード番号" :value="payment.creditResult.maskedCardNo"/>
                <FormConfirm label="お支払い回数" :value="payTimes"/>
            </div>
        </section>
        <SectionLabel>申し込み詳細</SectionLabel>
        <section class="content">
            <ApplyDetailTable :price="price" :is-selected="true"/>
        </section>
        <SectionLabel>受験規約</SectionLabel>
        <section class="content">
            <label>
                規約を読んで同意しました
            </label>
            <div class="mt-10 lg:flex flex-row gap-4">
                <div class="flex-1">
                    <button type="button"
                            class="w-full text-base transition rounded-full bg-main-color p-1"
                            @click="$emit('cancel')" :disabled="isProcessing">
                        <span class="flex items-center justify-center text-white font-medium relative p-2">
                            入力に戻る
                        </span>
                    </button>
                </div>
                <div class="flex-1">
                    <button type="button"
                            class="w-full text-base transition rounded-full bg-main-color p-1"
                            @click="$emit('submit')" :disabled="isProcessing">
                         <span class="flex items-center justify-center text-white font-medium relative p-2">
                        申し込みをする
                               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor"
                                    class="w-6 h-6 absolute right-2 top-0 bottom-0 my-auto">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                        </svg>
                         </span>
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SectionLabel from "./SectionLabel";
import FormLabel from "./FormLabel";
import FormConfirm from "./FormConfirm";
import ApplyDetailTable from "./ApplyDetailTable";
import ConfirmHeader from "./ConfirmHeader";

export default {
    name: "StartConfirm",
    components: {ConfirmHeader, ApplyDetailTable, FormConfirm, FormLabel, SectionLabel},
    props: {
        request: {
            type: Object,
        },
        payment: {
            type: Object,
        },
        isProcessing: {
            type: Boolean
        },
        price: {
            type: Object
        }
    },

    computed: {
        payTimes() {
            if (this.request.pay_times === 'bonus') {
                return 'ボーナス払';
            } else {
                return `${this.request.pay_times}回払`;
            }
        }
    }
}
</script>

<style scoped>

</style>
